export default function Webidpage() {

    return (
<div>web id</div>
    )
}
